import {URL_ROLE, fetchBody, URL_LOGIN, URL_ACCOUNT_REGISTER, loginPageInfo} from "../config"
import md5 from "md5"
import axios from 'axios';
import { toFetch, cleanFetch } from "./apiTools";


export const toLogin = ({mReqLogin, success, failure}) => {
  //console.log(mReqLogin)
  //console.log(fetchBody({body: mReqLogin} ))
  cleanFetch({
    body: fetchBody({body: mReqLogin} ), 
    url: URL_LOGIN, 
    success, failure
  })
}
  
export const toLogout = (token, fn) =>{
  fn();
}

export const checkToken = (token, fn) => {
  var obj = {
    token:token,
  }
  toFetch(obj, loginPageInfo.getServerUrl() + 'checkToken')
}

export const getRoleId = (token, departmentId, fn) => {
  var obj = {
    token:token,
    departmentId: departmentId
  }
  toFetch(obj, URL_ROLE + 'getRoleId', fn)
}
//註冊
export const register = (token, roleId, mobile, password, nickName, email, success, failure) => {
  var obj = {
    token: token,
    roleId: roleId,
    mobile: mobile,
    password: password,
    nickName: nickName,
    email: email
  }
  cleanFetch({
    body: fetchBody({body: obj} ), 
    url: URL_ACCOUNT_REGISTER, 
    success, failure
  })
}

export const test = (fn) => {
  var obj = {
    "CompanyName": "string",
    "TaxIdNumber": "string",
    "ContactName": "string"
  }
  fetch("https://platform-api.zerozero.com.tw/Customer/Search", 
  {
    method: 'POST',
    headers: {
      'Authorization' : 'bearer eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJzdWJqZWN0IiwidXNlcklkIjoiWk9TWVdZMzU4IiwiZXhwIjoxNTYzOTQ3OTQ2LCJyb2xlcyI6WyJhZG1pbmlzdHJhdG9yIl0sImF2YWlsYWJsZUFQSXMiOlsiL2FjY2Vzcy9saXN0IiwiL2FjY2Vzcy9yb2xlL2FwaXMiLCIvYXBpdXNlci9jcmVhdGUiLCIvYXBpdXNlci9leGlzdC97aWR9IiwiL2FwaXVzZXIvc2VhcmNoIiwiL2FwaXVzZXIvdXBkYXRlIiwiL2FwaXVzZXIve2lkfSIsIi9hcHBsaWNhdGlvbi9jcmVhdGUiLCIvYXBwbGljYXRpb24vZXhpc3Qve2lkfSIsIi9hcHBsaWNhdGlvbi9mdW5jdGlvbnMve2lkfSIsIi9hcHBsaWNhdGlvbi9saXN0IiwiL2FwcGxpY2F0aW9uL2xpc3Qve2xhbmdDb2RlfSIsIi9hcHBsaWNhdGlvbi91cGRhdGUiLCIvYXBwbGljYXRpb24ve2lkfSIsIi9jb21tb24vY291bnRpZXMiLCIvY29tbW9uL2RlbGV0ZUltYWdlL3trZXlOYW1lfSIsIi9jb21tb24vbGFuZ0NvZGVzIiwiL2NvbW1vbi90b3duc2hpcHMve2NpZH0iLCIvY29tbW9uL3VwbG9hZEltYWdlcyIsIi9mdW5jdGlvbi9jcmVhdGUiLCIvZnVuY3Rpb24vZGVsZXRlL3tpZH0iLCIvZnVuY3Rpb24vZXhpc3Qve2lkfSIsIi9mdW5jdGlvbi9zZWFyY2giLCIvZnVuY3Rpb24vdXBkYXRlIiwiL2Z1bmN0aW9uL3tpZH0iLCIvbWVudS9saXN0IiwiL3JvbGUvYXNzaWduRnVuY3MiLCIvcm9sZS9jcmVhdGUiLCIvcm9sZS9kZWxldGUve2lkfSIsIi9yb2xlL2V4aXN0L3tpZH0iLCIvcm9sZS9mdW5jdGlvbnMvYWxsL3tsYW5nQ29kZX0iLCIvcm9sZS9mdW5jdGlvbnMve3JvbGVJZH0iLCIvcm9sZS9zZWFyY2giLCIvcm9sZS91cGRhdGUiLCIvcm9sZS97aWR9IiwiL3VzZXIvYXNzaWduUm9sZXMiLCIvdXNlci9jcmVhdGUiLCIvdXNlci9sb2dpbiIsIi91c2VyL2xvZ291dCIsIi91c2VyL25vdGlmaWNhdGlvbnMiLCIvdXNlci9yZWZyZXNoVG9rZW4iLCIvdXNlci9yb2xlcyIsIi91c2VyL3NlYXJjaCIsIi91c2VyL3NldFBhc3N3b3JkIiwiL3VzZXIvc2lnblVwIiwiL3VzZXIvdXBkYXRlIiwiL3VzZXIve2lkfSJdLCJhcHBsaWNhdGlvbklkIjoiemVyb3plcm8tYWRtIn0.GdlgsaYlRArQ2bXDH6Edg3iktEH1F7MiyVG5pwdbVQ1cvs1jDULVjuHfufSFJ8Pf2AwN0fe1tQTfCbt8BX7uqMQ-vbzGTF4CPyRIkj_-AwY_E6d67AkhAtcdSdym-b3hdUoY_1iIhTvk0HwRi7xXFMlhWCjCM6W1Ws04ILTPZq0PheLXejHZelumcJauhS0KmIfYsX_a2VYBC5lL_u4qv20r_gWGCCZ4HJgcevmcnggX1qIdm7FHbVahn9xh3qXlPO2NZVZbK0p4UCFDY50QzqdrfiFNpvvNTlqgo2xZj2kImo_LXcDFUer7KNBRLAt23GKgyb6Wm9n1YsXHBbpcQw',  
      // 'Content-Type': 'application/json',
      'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
      'accept': 'application/json',
    },
    crossDomain:true,
    mode: 'cors',
    body: JSON.stringify(obj)
  }
  /*
  {
    method: 'GET',
    headers: {
      //'Authorization' : 'Bearer eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJzdWJqZWN0IiwidXNlcklkIjoiWk9TWVdZMzU4IiwiZXhwIjoxNTYzNzc0NDUzLCJyb2xlcyI6WyJhZG1pbmlzdHJhdG9yIl0sImF2YWlsYWJsZUFQSXMiOlsiL2FjY2Vzcy9saXN0IiwiL2FjY2Vzcy9yb2xlL2FwaXMiLCIvYXBpdXNlci9jcmVhdGUiLCIvYXBpdXNlci9leGlzdC97aWR9IiwiL2FwaXVzZXIvc2VhcmNoIiwiL2FwaXVzZXIvdXBkYXRlIiwiL2FwaXVzZXIve2lkfSIsIi9hcHBsaWNhdGlvbi9jcmVhdGUiLCIvYXBwbGljYXRpb24vZXhpc3Qve2lkfSIsIi9hcHBsaWNhdGlvbi9mdW5jdGlvbnMve2lkfSIsIi9hcHBsaWNhdGlvbi9saXN0IiwiL2FwcGxpY2F0aW9uL2xpc3Qve2xhbmdDb2RlfSIsIi9hcHBsaWNhdGlvbi91cGRhdGUiLCIvYXBwbGljYXRpb24ve2lkfSIsIi9jb21tb24vY291bnRpZXMiLCIvY29tbW9uL2RlbGV0ZUltYWdlL3trZXlOYW1lfSIsIi9jb21tb24vbGFuZ0NvZGVzIiwiL2NvbW1vbi90b3duc2hpcHMve2NpZH0iLCIvY29tbW9uL3VwbG9hZEltYWdlcyIsIi9mdW5jdGlvbi9jcmVhdGUiLCIvZnVuY3Rpb24vZGVsZXRlL3tpZH0iLCIvZnVuY3Rpb24vZXhpc3Qve2lkfSIsIi9mdW5jdGlvbi9zZWFyY2giLCIvZnVuY3Rpb24vdXBkYXRlIiwiL2Z1bmN0aW9uL3tpZH0iLCIvbWVudS9saXN0IiwiL3JvbGUvYXNzaWduRnVuY3MiLCIvcm9sZS9jcmVhdGUiLCIvcm9sZS9kZWxldGUve2lkfSIsIi9yb2xlL2V4aXN0L3tpZH0iLCIvcm9sZS9mdW5jdGlvbnMvYWxsL3tsYW5nQ29kZX0iLCIvcm9sZS9mdW5jdGlvbnMve3JvbGVJZH0iLCIvcm9sZS9zZWFyY2giLCIvcm9sZS91cGRhdGUiLCIvcm9sZS97aWR9IiwiL3VzZXIvYXNzaWduUm9sZXMiLCIvdXNlci9jcmVhdGUiLCIvdXNlci9sb2dpbiIsIi91c2VyL2xvZ291dCIsIi91c2VyL25vdGlmaWNhdGlvbnMiLCIvdXNlci9yZWZyZXNoVG9rZW4iLCIvdXNlci9yb2xlcyIsIi91c2VyL3NlYXJjaCIsIi91c2VyL3NldFBhc3N3b3JkIiwiL3VzZXIvc2lnblVwIiwiL3VzZXIvdXBkYXRlIiwiL3VzZXIve2lkfSJdLCJhcHBsaWNhdGlvbklkIjoiemVyb3plcm8tYWRtIn0.NvBb6XS3dsGmNZjWJKlYF3j5U3p6IhspkAg6n-LFc2oucNqWXYjVQv4r2kCdRjaDnrqmoiTW5L83mo6DWmRDnoYtUIwaMNn98pnWJhQ4aFg0t-vJAINLR2IU0OY86I_3r9fP0U5WNGSfySo8Zt1udsd0wUweYkmXYsWeztodwy6eo26cdpMj6anq098DbnT5IptBaFFfFSvTVt5XfeYV8LbnchBnmlV5cR2gZbuMpT5fYez2xZqO5LWA3See-0gccasrKIlJ1wlsKLsuqZnOAmXBC7HDjgKO00Zz_mVQJ6ztn4UN4csD33K2I-y_AVYtJR89gMuchgLGALKBMu91jw',  
      //'Content-Type': 'application/json',
      'accept': 'application/json',
    },
    crossDomain:true,
    mode: 'cors',
  }
  */
  /*
{
  crossDomain:true,
  method: 'POST',
  headers: {
  'Content-Type': 'application/json',
  'accept': 'application/json',
  'Access-Control-Allow-Origin': '*'

  },
  // body 將 json 轉字串送出
  mode: 'cors',
  body: obj
  
  //body: body2String(obj)
 }
 */
  )
  .then((response) => {
      console.log(response);
    return response.json();
  }).then((jsonDate)=>{
    console.log(jsonDate)
    //fn(jsonDate.status, jsonDate.list, jsonDate.count);
  }).catch((err)=>{
    console.log("錯誤 :", err)
    fn(false);
  })
  return;
}

export const ios = () => {
  var obj = {
    "CarPlateNum": "string",
    "CarType": "string",
    "CarTons": 0
  }

  var AUTH_TOKEN = 'Bearer eyJhbGciOiJSUzUxMiJ9.eyJzdWIiOiJzdWJqZWN0IiwidXNlcklkIjoiWk9TWVdZMzU4IiwiZXhwIjoxNTYzNzc0NDUzLCJyb2xlcyI6WyJhZG1pbmlzdHJhdG9yIl0sImF2YWlsYWJsZUFQSXMiOlsiL2FjY2Vzcy9saXN0IiwiL2FjY2Vzcy9yb2xlL2FwaXMiLCIvYXBpdXNlci9jcmVhdGUiLCIvYXBpdXNlci9leGlzdC97aWR9IiwiL2FwaXVzZXIvc2VhcmNoIiwiL2FwaXVzZXIvdXBkYXRlIiwiL2FwaXVzZXIve2lkfSIsIi9hcHBsaWNhdGlvbi9jcmVhdGUiLCIvYXBwbGljYXRpb24vZXhpc3Qve2lkfSIsIi9hcHBsaWNhdGlvbi9mdW5jdGlvbnMve2lkfSIsIi9hcHBsaWNhdGlvbi9saXN0IiwiL2FwcGxpY2F0aW9uL2xpc3Qve2xhbmdDb2RlfSIsIi9hcHBsaWNhdGlvbi91cGRhdGUiLCIvYXBwbGljYXRpb24ve2lkfSIsIi9jb21tb24vY291bnRpZXMiLCIvY29tbW9uL2RlbGV0ZUltYWdlL3trZXlOYW1lfSIsIi9jb21tb24vbGFuZ0NvZGVzIiwiL2NvbW1vbi90b3duc2hpcHMve2NpZH0iLCIvY29tbW9uL3VwbG9hZEltYWdlcyIsIi9mdW5jdGlvbi9jcmVhdGUiLCIvZnVuY3Rpb24vZGVsZXRlL3tpZH0iLCIvZnVuY3Rpb24vZXhpc3Qve2lkfSIsIi9mdW5jdGlvbi9zZWFyY2giLCIvZnVuY3Rpb24vdXBkYXRlIiwiL2Z1bmN0aW9uL3tpZH0iLCIvbWVudS9saXN0IiwiL3JvbGUvYXNzaWduRnVuY3MiLCIvcm9sZS9jcmVhdGUiLCIvcm9sZS9kZWxldGUve2lkfSIsIi9yb2xlL2V4aXN0L3tpZH0iLCIvcm9sZS9mdW5jdGlvbnMvYWxsL3tsYW5nQ29kZX0iLCIvcm9sZS9mdW5jdGlvbnMve3JvbGVJZH0iLCIvcm9sZS9zZWFyY2giLCIvcm9sZS91cGRhdGUiLCIvcm9sZS97aWR9IiwiL3VzZXIvYXNzaWduUm9sZXMiLCIvdXNlci9jcmVhdGUiLCIvdXNlci9sb2dpbiIsIi91c2VyL2xvZ291dCIsIi91c2VyL25vdGlmaWNhdGlvbnMiLCIvdXNlci9yZWZyZXNoVG9rZW4iLCIvdXNlci9yb2xlcyIsIi91c2VyL3NlYXJjaCIsIi91c2VyL3NldFBhc3N3b3JkIiwiL3VzZXIvc2lnblVwIiwiL3VzZXIvdXBkYXRlIiwiL3VzZXIve2lkfSJdLCJhcHBsaWNhdGlvbklkIjoiemVyb3plcm8tYWRtIn0.NvBb6XS3dsGmNZjWJKlYF3j5U3p6IhspkAg6n-LFc2oucNqWXYjVQv4r2kCdRjaDnrqmoiTW5L83mo6DWmRDnoYtUIwaMNn98pnWJhQ4aFg0t-vJAINLR2IU0OY86I_3r9fP0U5WNGSfySo8Zt1udsd0wUweYkmXYsWeztodwy6eo26cdpMj6anq098DbnT5IptBaFFfFSvTVt5XfeYV8LbnchBnmlV5cR2gZbuMpT5fYez2xZqO5LWA3See-0gccasrKIlJ1wlsKLsuqZnOAmXBC7HDjgKO00Zz_mVQJ6ztn4UN4csD33K2I-y_AVYtJR89gMuchgLGALKBMu91jw';
//使用库提供的配置默认值创建实例
//此时，超时配置值为`0`，这是库的默认值
var instance = axios.create();
instance.defaults.headers.common['Authorization'] = AUTH_TOKEN;
instance.defaults.withCredentials = true;
 
//覆盖此请求的超时，因为它知道需要很长时间
instance.post('https://platform-api.zerozero.com.tw/Car/Search', 
    obj
  )
  .then(function (response) {
    console.log(response);
  })
  .catch(function (error) {
    if(error.response){
      //请求已发出，但服务器使用状态代码进行响应
      //落在2xx的范围之外
      console.log(error.response.data);
      console.log(error.response.status);
      console.log(error.response.headers);
    } else {
      //在设置触发错误的请求时发生了错误
      console.log('Error'+ error.message);
    }

    console.log(error.config);
  });
}